import { render } from "./padel-signup.template.html?vue&type=template&id=e8647b30&scoped=true"
import script from "./PadelSignup.vue?vue&type=script&lang=js"
export * from "./PadelSignup.vue?vue&type=script&lang=js"

import "./PadelSignup.vue?vue&type=style&index=0&id=e8647b30&lang=scss&scoped=true"
import "./PadelSignup.vue?vue&type=style&index=1&id=e8647b30&lang=scss"
script.render = render
script.__scopeId = "data-v-e8647b30"

export default script